<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
    <p style="color: white"> Please Wait Loading... </p>
</ngx-spinner>
<div class="app-body">
    <main class="main d-flex p-2">
        <div class="col-md-4 offset-md-4">
            <div class="card-body">
                <form [formGroup]="loginFormGroup">
                    <div class="card-group logfrm">
                        <h1><strong>SGRC</strong></h1>
                        <div class="input-group mb-4">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="icon-user loginicon"></i></span>
                            </div>
                            <input type="email" class="form-control" placeholder="Email" formControlName="email"
                                autocomplete="email" style="height: 50px; font-size: 20px;"
                                [ngClass]="{'is-invalid': submitted && email.errors}">
                            <div *ngIf=" submitted &&email.errors" class="invalid-feedback">
                                <div *ngIf="email.errors.required">Email Id Is
                                    Required</div>
                                <div *ngIf="email.errors.email"> In-Valid
                                    E-Mail
                                    Address</div>
                            </div>
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text "><i class="icon-lock loginicon"></i></span>
                            </div>
                            <input type="password" class="form-control" placeholder="Password"
                                autocomplete="current-password" formControlName="password"
                                [ngClass]="{ 'is-invalid': submitted && password.errors }"
                                style="height: 50px; font-size: 20px;">
                            <div *ngIf="submitted &&password.errors" class="invalid-feedback" class="invalid-feedback">
                                <div *ngIf="password.errors.required ">Password Is
                                    Required</div>
                                <div *ngIf="password.errors.minlength"> Must
                                    be Atleast 6
                                    Characters!!!</div>
                            </div>
                        </div>
                        <span *ngIf="!result" class="invalid-email-password-error">
                            Enter Valid E-mail and Password</span>
                        <div class="row btnrow">
                            <div class="col-sm-5">
                                <button type="submit" class="btn btn-primary" (click)="logIn()"
                                    style="font-size: 17px;"><strong>Login </strong>
                                    <i class="fa fa-sign-in" aria-hidden="true"></i></button>
                            </div>
                            <div class="col-sm-7">
                                <button type="button" class="btn btn-link " [routerLink]="['/forgetpassword']"><strong
                                        style="color: rgb(4, 65, 83); font-size: 19px;">Forgot
                                        password?</strong></button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
</div>
